<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>COMPROBANTES CANCELADOS</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 100%;" class="pa-0">
      <v-data-table
        must-sort
        :headers="headers"
        :items="items"
        :pagination.sync="paginacion"
        :total-items="totalItems"
        :rows-per-page-items="itemsPorPagina"
        :loading="cargando"
        class="elevation-1"
      >
        <v-progress-linear
          v-slot:progress
          color="blue"
          indeterminate
          v-if="cargando"
        ></v-progress-linear>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left pa1">{{ props.item.comprobante.fecha | formatoFecha }}</td>
            <td class="text-xs-left pa1">{{ props.item.comprobante | cabeceraComprobante }}</td>
            <td class="text-xs-left pa1">{{ props.item.comprobante.concepto_descripcion }}</td>
            <td class="text-xs-right pa1">
              {{
                (props.item.comprobante.importe_facturado *
                  (props.item.comprobante.tipo_comprobante.codigo === 'NC' ? -1 : 1))
                  | currency
              }}
            </td>
            <td class="text-xs-right pa1">
              {{
                (props.item.importe *
                  (props.item.comprobante.tipo_comprobante.codigo === 'NC' ? -1 : 1))
                  | currency
              }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="false"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { formatoFecha, nombreCentro, cabeceraComprobante } from '@/helpers/filtros'
import Modelo from '@/api/recibo'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'

export default {
  name: 'ReciboDetalleComprobante',
  components: {
    BotonesCancelarGuardar
  },
  filters: {
    formatoFecha,
    nombreCentro,
    cabeceraComprobante
  },
  props: {
    reciboId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      filtros: {
        search: null
      },
      totalItems: 0,
      headers: [
        { text: 'Fecha', value: 'fecha', sortable: false },
        { text: 'Tipo/Letra/Pto.Vta./Nro', value: 'tipo_comprobante_id', sortable: false },
        { text: 'Concepto', value: 'concepto_descripcion', sortable: false, align: 'left' },
        { text: 'Importe facturado', value: 'importe_facturado', sortable: false, align: 'right' },
        { text: 'Importe cancelado', value: 'importe_cobrado', sortable: false, align: 'right' }
      ],
      items: [],
      paginacion: {},
      itemsPorPagina: [20, 50, 100],
      cargando: false,
      itemSeleccionado: null
    }
  },
  watch: {
    paginacion: {
      handler () {
        this.filtrarDatos()
      },
      deep: true
    }
  },
  mounted () {
    let vm = this
    vm.filtrar()
  },
  methods: {
    filtrar () {
      let vm = this

      vm.filtros.page = 1
      vm.filtrarDatos()
    },
    cerrar () {
      this.$emit('alCerrar')
    },
    filtrarDatos () {
      let vm = this
      let _filtros = _.assign({}, vm.filtros)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.cargando = true
      vm.metodoFiltrar(_filtros).then(
        data => {
          vm.items.lenght = 0
          vm.items = data.data
          vm.totalItems = data.total
          vm.cargando = false
        },
        error => {
          this.$emit('mostrarError', error)
          vm.cargando = false
        }
      )
    },
    metodoFiltrar (filtros) {
      let vm = this

      filtros.reciboId = vm.reciboId
      return Modelo.obtenerDetalleComprobantes(vm.reciboId, filtros)
    }
  }
}
</script>
<style scoped></style>
